if (typeof RecentlyViewed !== 'function') {
  class RecentlyViewed extends HTMLElement {

    constructor() {
      super();

      this.carousel = this.querySelector('.flickity-gallery');
      let promises = [];

      const productHandles = JSON.parse(localStorage.getItem('recently_viewed'));
      const sectionId = this.dataset.id;

      if (!productHandles)
        return;

      productHandles.forEach(handle => {
        promises.push(
          fetch(`/products/${handle}?section_id=${sectionId}`)
            .then(response => response.text())
            .then(text => {
              return new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('[data-js-product-item]');
            }));
      });

      if (productHandles.length > 0) {
        this.parentElement.classList.remove('hide');
        Promise.all(promises).then((results) => {
          results.forEach((productItem) => {
            if (productItem) {
              this.carousel.insertAdjacentHTML("beforeend", productItem.outerHTML);
            }
          })

          $(this.carousel).flickity({
            contain: true,
            prevNextButtons: true,
            pageDots: true,
            groupCells: true,
            cellAlign: 'left'
          });
        });
      }

    }
  }

  if (typeof customElements.get("recently-viewed") == "undefined") {
    customElements.define("recently-viewed", RecentlyViewed);
  }
}
